"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const clean_1 = __importDefault(require("./clean"));
const dotGetSchema_1 = __importDefault(require("./dotGetSchema"));
const defaultOptions = {
    filter: true
};
async function default_1(schema, key, value, passedOptions = {}, ...args) {
    const options = { ...defaultOptions, ...passedOptions };
    const keySchema = (0, dotGetSchema_1.default)(schema, key);
    if (!keySchema) {
        if (options.filter) {
            return;
        }
        else {
            return value;
        }
    }
    const result = await (0, clean_1.default)({ clean: keySchema }, { clean: value }, options, ...args);
    return result.clean;
}
exports.default = default_1;
